// @ts-nocheck

import { size as _size, mapValues as _mapValues, reduce as _reduce } from 'lodash';

import { BasketModes, BasketStatuses, BasketItemStatuses } from '../../../types/basket';
import { basket as BasketUtils } from '../../../utils';
import { getStakeFromPresets } from '../../../utils/presets';
const { formatStake } = BasketUtils;

/**
 * Return the nextState corresponding to the BASKET_GET_SELECTION action
 *
 * @static
 * @param  {Object} state  The actual state
 * @return {Object}        Return the new state.
 */
const basketGetSelection = (state, action, completeStore) => {
  const { itemsMemoizedForSelection, stake, mode } = state;
  const userPresets = completeStore?.user?.presets;
  let newStake = stake;

  if (_size(itemsMemoizedForSelection) > 0) {
    const nextItems = _mapValues(itemsMemoizedForSelection, (item) => {
      if (userPresets) {
        const presetStake = getStakeFromPresets(userPresets, item.value);
        newStake = presetStake ? formatStake(presetStake) : newStake;
      }
      return {
        ...item,
        status: BasketItemStatuses.OK,
        stake: newStake,
      };
    });
    if (userPresets && mode !== BasketModes.SYSTEM) {
      const odds = _reduce(nextItems, (acc, { value, validatedValue }) => acc * (validatedValue || value), 1);
      newStake = getStakeFromPresets(userPresets, odds) || newStake;
      const presetStake = getStakeFromPresets(userPresets, odds);
      newStake = presetStake ? formatStake(presetStake) : newStake;
    }
    return {
      ...state,
      items: nextItems,
      status: BasketStatuses.OK,
      betslipId: undefined,
      itemsValidated: undefined,
      itemsWaiting: undefined,
      // selectedFreebetId: undefined,
      itemsMemoizedForSelection: {},
      stake: newStake,
    };
  }
  return state;
};

export default basketGetSelection;
